// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'
import {createCookie} from './utils/cookie.js'
import { Fancybox } from "@fancyapps/ui";
import './utils/svg';

import './partials/animations';
import './partials/forms';
import './partials/inputs';
import './partials/newsletter';
import './partials/posts';
import './partials/menu';

$(function() {

    $('.menu-open, .menu-close').click(function(e){
        $('header .menu-primary-container').slideToggle();
        e.preventDefault();
    });
    $('.menu-open').click(function(){
        $('.menu-close').show();
        $(this).hide();
    });
    $('.menu-close').click(function(){
        $('.menu-open').show();
        $(this).hide();
    });

    $('.top').click(function(e){
        $("html, body").animate({ scrollTop: 0 }, "slow");
        e.preventDefault();
    });

    $(".cookies-close, .cookies-regulation .button").click(function () {
        createCookie('cookies-accepted', 'yes', 31);
        $(".cookies-regulation").animate({bottom:-350}, 600).fadeOut();
        return false;
    });

    $('.popup .close').click(function(e){
        $('.popup.show').removeClass('show');
        $('body').removeClass('not-scroll');
        //e.preventDefault();
    });
});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js